<section class="report-summary-header">
   <div class="report-brand">
      <img
         alt="tyalls"
         height="40"
         id="app-logo"
         ngSrc="https://tyalls-images.s3.ap-southeast-2.amazonaws.com/app/logo/Tyalls_CMYK_logo_default.svg"
         priority
         width="100"
      />
   </div>

   <div class="report-title-area">
      <h2>{{ title }}</h2>

      <div class="report-business-date" *ngIf="businessDateText">
         <span class="label">{{ businessDateLabel }}:</span>
         <span class="value">{{ businessDateText }}</span>
      </div>
   </div>

   <div class="report-snippets" *ngIf="snippets.length || totalReportValueText">
      <div
         class="report-snippet"
         *ngFor="let snippet of snippets"
         [ngClass]="getSnippetToneClass(snippet)"
      >
         <div class="snippet-label">{{ snippet.label }}</div>

         <div class="snippet-value">
            {{ snippet.value }}

            <span class="snippet-suffix" *ngIf="snippet.suffix">
               {{ snippet.suffix }}
            </span>
         </div>
      </div>

      <div
         class="report-snippet report-total-report-value"
         *ngIf="totalReportValueText"
      >
         <div class="snippet-label">Total Report Value</div>

         <div class="snippet-value">
            {{ totalReportValueText }}
         </div>
      </div>
   </div>
</section>
